import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root'
})

/** The NavigationService class provides a way to navigate back to the previous page or a specified URL
using the router and location services in Angular. */
export class NavigationService {

  private _history: string[] = [];

  constructor(private _router: Router, private _location: Location) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this._history.push(event.urlAfterRedirects);
        // console.log(this._history);
      }
    })
  }

  /**
   * This function pops the last item from the history array and navigates back to the previous page
   * using the location service, or navigates to a specified URL using the router service if there are
   * no more items in the history array.
   * @param {string} [url=/] - A string representing the URL to navigate to if there is no history to
   * go back to. The default value is '/' which represents the root URL.
   */
  public back(url: string = '/'): void {
    this._history.pop();
    if(this._history.length > 0) {
      this._location.back();
    } else {
      this._router.navigateByUrl(url);
    }
  }

}
